import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import http from '../../services/http';
import { useAuthContext } from '../../contexts/AuthContext';
import { Input, PasswordInput, Button, Alert } from '../ui';
import { useForm } from '../../hooks/useForm';
import { logger } from '../../utils/logger';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuthContext();

  const { values, handleChange } = useForm({
    email: '',
    password: ''
  });

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await http.post('/api/auth/login', values);
      const { user } = response.data;

      // Context'e yaz — localStorage doğrudan manipüle edilmiyor
      login(user);

      navigate('/');

    } catch (err: any) {
      logger.error('Giriş hatası:', err);
      setError(err.response?.data?.message || 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(135deg, #0065a5 0%, #00406b 100%)' }}>
      <div className="bg-white/95 backdrop-blur-xl p-8 rounded-2xl shadow-2xl w-full max-w-md border border-white/20">

        <div className="flex flex-col items-center justify-center mb-8">
          <div className="w-20 h-20 rounded-full border-2 border-primary/20 mb-4 overflow-hidden shadow-md bg-white p-1">
            <img
              src="/sidebar_logo.png"
              alt="Logo"
              className="w-full h-full object-contain"
            />
          </div>
          <h2 className="text-xl font-bold text-gray-800 text-center leading-tight">
            TrioCare CRM
          </h2>
          <p className="text-sm text-gray-400 mt-1">Yönetim Paneli</p>
        </div>

        {error && (
          <div className="mb-6">
            <Alert type="error">{error}</Alert>
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-5">
          <Input
            label="Email"
            name="email"
            type="email"
            value={values.email}
            onChange={handleChange}
            placeholder="ornek@sirket.com"
            required
            autoFocus
          />

          <PasswordInput
            label="Şifre"
            name="password"
            value={values.password}
            onChange={handleChange}
            placeholder="******"
            required
          />

          <div className="pt-2">
            <Button
              type="submit"
              variant="primary"
              className="w-full py-3"
              loading={loading}
              disabled={loading}
              icon={!loading ? <LogIn size={20} /> : undefined}
            >
              {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
            </Button>
          </div>
        </form>

        <div className="mt-5 text-center">
          <Link
            to="/forgot-password"
            className="text-sm text-primary hover:text-primary-dark font-medium"
          >
            Şifremi unuttum
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
